export default __webpack_public_path__ + "static/media/the_devil.05747fb8.png";